import React, { Component } from "react";
import { Alert } from "@americanexpress/dls-react";
import FileUploader from "./FileUploader";
import { withTranslation } from "react-i18next";
import { validateUploadFile, validationStateFromResult } from "../../util/uploadUtils";
import { UPLOAD_MESSAGES } from "../Common/constants";
import "./FileUploader.css";

class Upload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
      file: null,
      files: this.props.files || [],
      invalidSize: false,
      invalidType: false,
      invalidPdf: false,
      invalidPdfMessage: "",
      isLoading: false,
    };
  }

  dragEventCounter = 0;

  dragenterListener = (event) => {
    this.overrideEventDefaults(event);
    this.dragEventCounter++;
    if (event.dataTransfer.items && event.dataTransfer.items[0]) {
      this.setState({ dragging: true });
    } else if (
      event.dataTransfer.types &&
      event.dataTransfer.types[0] === "Files"
    ) {
      // This block handles support for IE - if you're not worried about
      // that, you can omit this
      this.setState({ dragging: true });
    }
  };

  dragleaveListener = (event) => {
    this.overrideEventDefaults(event);
    this.dragEventCounter--;

    if (this.dragEventCounter === 0) {
      this.setState({ dragging: false });
    }
  };

  dropListener = (event) => {
    let fileArr = this.props.files || this.state.files;
    this.overrideEventDefaults(event);
    this.dragEventCounter = 0;
    this.setState({ dragging: false });

    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      this.checkValidity(event.dataTransfer.files[0], fileArr);
    }
  };

  overrideEventDefaults = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  onSelectFileClick = () => {
    this.fileUploaderInput && this.fileUploaderInput.click();
  };

  onFileChanged = (event) => {
    let files = this.props.files || this.state.files;
    if (event.target.files && event.target.files[0]) {
      this.checkValidity(event.target.files[0], files);
    }
    event.target.value = null;
  };

  updateFile = (fileObj) => {
    if (fileObj?.length >= 0) {
      this.props.getFile(fileObj);
    }
  };

  checkValidity = async (fileObj, fileArr) => {
    this.setState({ isLoading: true });
    try {
      const res = await validateUploadFile(fileObj);
      const validationErrors = validationStateFromResult(res);

      if (!res.valid) {
        this.setState({ ...validationErrors, isLoading: false });
        return;
      }

      const nextFiles = [...(fileArr || []), res.doc];
      this.setState({ ...validationErrors, files: nextFiles, isLoading: false });
      this.updateFile(nextFiles);
    } catch (err) {
      this.setState({
        invalidSize: false,
        invalidType: false,
        invalidPdf: true,
        invalidPdfMessage: UPLOAD_MESSAGES.FILE_READER_ERROR,
        isLoading: false,
      });
    }
  };

  removeFile = (index) => {
    const { t } = this.props;
    var files = [];
    if (this.props.fileuploadded != undefined) {
      this.props.fileuploadded.map((fun) => {
        if (fun.functionName === t("products.functname2")) {
          fun.roles.map((role) => {
            if ((role.roleName = t("products.role-approver"))) {
              files = role.files;
            }
          });
        }
      });
    } else {
      files = this.props.files || this.state.files;
    }
    var array = (files || []).filter((_, pos) => pos !== index);
    this.setState({ files: array });
    this.updateFile(array);
  };

  componentDidMount() {
    window.addEventListener("dragover", (event) => {
      this.overrideEventDefaults(event);
    });
    window.addEventListener("drop", (event) => {
      this.overrideEventDefaults(event);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("dragover", this.overrideEventDefaults);
    window.removeEventListener("drop", this.overrideEventDefaults);
  }

  render() {
    const { t, isModifyUser } = this.props;
    var { file, isLoading } = this.state;
    var filesnew = [];

    if (this.props.fileuploadded != undefined) {
      this.props.fileuploadded.map((fun) => {
        if (fun.functionName === t("products.functname2")) {
          fun.roles.map((role) => {
            if ((role.roleName = t("products.role-approver"))) {
              filesnew = role.files;
            }
          });
        }
      });
    }
    return (
      <FileUploader
        dragging={this.state.dragging}
        file={file}
        isModifyUser={isModifyUser}
        isLoading={isLoading}
        files={this.props.fileuploadded !== undefined ? filesnew : (this.props.files || this.state.files)}
        onSelectFileClick={this.onSelectFileClick}
        onDrag={this.overrideEventDefaults}
        onDragStart={this.overrideEventDefaults}
        onDragEnd={this.overrideEventDefaults}
        onDragOver={this.overrideEventDefaults}
        onDragEnter={this.dragenterListener}
        onDragLeave={this.dragleaveListener}
        onDrop={this.dropListener}
        removeFile={this.removeFile}
        country={this.props.country}
      >
        {this.state.invalidSize ? (
          <Alert>{UPLOAD_MESSAGES.INVALID_SIZE}</Alert>
        ) : null}
        {this.state.invalidType ? <Alert>{UPLOAD_MESSAGES.INVALID_TYPE}</Alert> : null}
        {this.state.invalidPdf ? (
          <Alert>{this.state.invalidPdfMessage || UPLOAD_MESSAGES.INVALID_PDF}</Alert>
        ) : null}
        <input
          ref={(el) => (this.fileUploaderInput = el)}
          type="file"
          className="fileUploader__Input"
          onChange={this.onFileChanged}
        />
      </FileUploader>
    );
  }
}

export default withTranslation("common")(Upload);
